import React from "react";

const SaleRate = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Sale Rate of Agro Chemicals/Pesticides/Weedicides/Insecticides</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <h6>
          Sale Rate of Agro Chemicals (Pesticides / Weedicides /Insecticides)
          for sale to the farmers during the year 2023-24:-
        </h6>

        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <th colspan="4">(Rate Rs. Per Packing)</th>
              </tr>
              <tr>
                <th>Sr.No.</th>
                <th>Name of product</th>
                <th>Packing size</th>
                <th> Sale rate to farmers including GST</th>
              </tr>
              <tr>
                <td>1</td>
                <td>Metsulfuron Methyal 20% WP</td>
                <td>Acre Dose</td>
                <td>30.00</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Thiamethoxam 25% WG</td>
                <td>1 Kg</td>
                <td>625.00</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Thiamethoxam 30% WG</td>
                <td>1 Ltr.</td>
                <td>730.00</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Thiamethoxam 30% WG</td>
                <td>500 mi.</td>
                <td>365.00</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Sulfosulfuron 75% WP</td>
                <td>Acre Dose</td>
                <td>255.00</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Clodinofop Propargyl 15% WP</td>
                <td>Acre Dose</td>
                <td>180.00</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Carbofuran 3% CG</td>
                <td>5 Kg</td>
                <td>370.00</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Methribuzin 70% WP</td>
                <td>100 gm</td>
                <td>120.00</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Sulphur 80% WDG</td>
                <td>3 Kg</td>
                <td>225.00</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Thiamethoxam 25% WG</td>
                <td>500 gm</td>
                <td>330.00</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Thiamethoxam 30% FS</td>
                <td>250ml</td>
                <td>195.00</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Propiconazole 25% EC</td>
                <td>250 ml</td>
                <td>170.00</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Propiconazole 25% EC</td>
                <td>500 ml</td>
                <td>325.00</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Propiconazole 25% EC</td>
                <td>1 Ltr.</td>
                <td>640.00</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Tebuconazole 38.39% SC</td>
                <td>250 ml</td>
                <td>325.00</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Tebuconazole 38.39% SC</td>
                <td>500 ml</td>
                <td>465.00</td>
              </tr>
              <tr>
                <td>17</td>
                <td>Tebuconazole 38.39% SC</td>
                <td>1 Ltr.</td>
                <td>910.00</td>
              </tr>
              <tr>
                <td>18</td>
                <td>Pendimethlin 30% EC</td>
                <td>500 ml</td>
                <td>180.00</td>
              </tr>
              <tr>
                <td>19</td>
                <td>Pendimethlin 30% EC</td>
                <td>1 Ltr.</td>
                <td>340.00</td>
              </tr>
              <tr>
                <td>20</td>
                <td>2, 4 - D Amine Salt 58% SL</td>
                <td>500 ml</td>
                <td>145.00</td>
              </tr>
              <tr>
                <td>21</td>
                <td>2, 4 - D Amine Salt 58% SL</td>
                <td>1 Ltr.</td>
                <td>275.00</td>
              </tr>
              <tr>
                <td>22</td>
                <td>Mancozeb 75% WP</td>
                <td>500 gm</td>
                <td>145.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SaleRate;
